import { ReactElement, useContext } from "react";
import { BuilderContext } from "./BuilderContext";

export const Toolbar = (): ReactElement | null => {
	const {
		setToolbarContainer
	} = useContext(BuilderContext);

	return (
		<div ref={setToolbarContainer} />
	);
};

Toolbar.displayName="Builder.Toolbar";